export default __webpack_public_path__ + "static/media/ClariceLovelace.0330644a.png";